import React from 'react'
import Loader from 'react-loader-spinner';

export const withLoading = (conditionFn) => (Component) => ({ top = false, ...props }) => {

  const renderLoading = () => conditionFn(props) && (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <Loader type="TailSpin" color="#5777FB" height="50" width="50"/>
    </div>
  );

  return (
    <div> 

      {top && renderLoading()}

      <Component {...props} />

      {!top && renderLoading()}

    </div>
  )
}

export const defaultLoadingCondition = ({ isLoading }) => isLoading;


// WEBPACK FOOTER //
// ./src/components/hocs/withLoading.js